import React from 'react';

export default function AnalyticsDownloadCell(cellData) {    

    var path = "api/main/AnalyticsDownload?fileId=" + cellData.data.analyticsId;

    if (cellData.column.dataField == "fileName") {
        return (
            <a href={path}>{cellData.value}</a>
        );
    }

    if (cellData.column.dataField == "description") {
        return (
            <a href={path}>{cellData.value}</a>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/analyticsManagement/analyticsDownloadCell.jsx